module.exports = __webpack_public_path__ + "img/ZA.dfc7babf.png";